<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <header>
    <div class="headline">
      <h1>
        @if (isEditing()) {
          {{ 'Step_Title' | translateWF: 'Step' }} {{ step()?.stepId }}
        } @else {
          {{ 'Step_New' | translateWF: 'New Step' }}
        }
      </h1>
    </div>
    <div class="buttons">
      <p-button [label]="'Common_Save' | translateWF: 'Save'" [disabled]="formGroup.invalid || !canEdit()" (click)="onSubmit()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" routerLink="/steps" />
    </div>
  </header>

  <div class="content">
    <form class="col" [formGroup]="formGroup">
      <p-panel [header]="'Step_Details' | translateWF: 'General Information'">
        <p-card>
          <div class="col">
            <div class="form-box">
              <label for="name">
                {{ 'Step_Name' | translateWF: 'Name' }}
              </label>
              <input type="text" id="name" formControlName="name" pInputText />
            </div>
            <div class="form-box">
              <label for="trackConsumption">
                {{ 'Step_Track_Consumption' | translateWF: 'Track Consumption' }}
              </label>
              <p-toggleswitch formControlName="trackConsumption" />
            </div>
          </div>
        </p-card>
      </p-panel>

      <app-parameter-details-viewer formControlName="additionalParameters" [canEdit]="canEdit()"></app-parameter-details-viewer>

      <app-item-details-viewer
        [(itemDetailsFormGroups)]="itemDetailsFormGroups"
        [inventoryTypeReference]="inventoryTypeReference()"
        [canEdit]="canEdit()"
      ></app-item-details-viewer>
    </form>
  </div>
</main>
